import React, { memo, SVGProps } from 'react'

export const Checklists = memo((props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}>
    <path
      d="M14.16 15.05H6.83C6.46 15.05 6.16 15.36 6.16 15.75C6.16 16.14 6.46 16.45 6.83 16.45H14.16C14.53 16.45 14.83 16.14 14.83 15.75C14.83 15.36 14.53 15.05 14.16 15.05Z"
      fill="currentColor"
    />
    <path
      d="M15.41 5.57H13.3C13 4.25 11.86 3.26 10.5 3.26C9.14 3.26 8.01 4.25 7.7 5.57H5.59C4.16 5.57 3 6.78 3 8.28V18.56C3 20.05 4.16 21.27 5.59 21.27H15.42C16.85 21.27 18.01 20.06 18.01 18.56V8.27C18.01 6.78 16.85 5.56 15.42 5.56L15.41 5.57ZM10.5 4.66C11.35 4.66 12.04 5.38 12.04 6.27C12.04 7.16 11.35 7.88 10.5 7.88C9.65 7.88 8.96 7.16 8.96 6.27C8.96 5.38 9.65 4.66 10.5 4.66ZM15.41 19.85H5.59C4.9 19.85 4.34 19.27 4.34 18.55V8.27C4.34 7.55 4.9 6.97 5.59 6.97H7.7C8 8.29 9.14 9.28 10.5 9.28C11.86 9.28 12.99 8.29 13.3 6.97H15.41C16.1 6.97 16.66 7.55 16.66 8.27V18.55C16.66 19.26 16.1 19.85 15.41 19.85Z"
      fill="currentColor"
    />
    <path
      d="M14.16 11.04H6.83C6.46 11.04 6.16 11.35 6.16 11.74C6.16 12.13 6.46 12.44 6.83 12.44H14.16C14.53 12.44 14.83 12.13 14.83 11.74C14.83 11.35 14.53 11.04 14.16 11.04Z"
      fill="currentColor"
    />
    <path
      d="M17.98 3H14.62C14.23 3 13.92 3.31 13.92 3.7C13.92 4.09 14.23 4.4 14.62 4.4H17.97C18.66 4.4 19.22 4.98 19.22 5.7V17.67C19.22 18.04 19.52 18.34 19.89 18.34C20.19 18.34 20.44 18.14 20.52 17.86C20.54 17.81 20.56 17.75 20.56 17.67V5.71C20.56 4.22 19.4 3 17.97 3H17.98Z"
      fill="currentColor"
    />
  </svg>
))
